// src/api/membership.js
import api from "../axios";

// 내 멤버십 전체 조회(주 소속 우선)
export const fetchMembership = () => api.get("membership/me/");

// 새 멤버십 생성 { company, department?, position?, is_primary? ... }
export const createMembership = (data) => api.post("membership/me/", data);

// 주 소속(또는 현재 주 소속 레코드) 갱신
export const updateMembership = (data) => api.put("membership/me/", data);

// 현재 백엔드 URL엔 삭제용 상세 엔드포인트가 없음
// 삭제가 필요하면 서버에 아래 URL을 추가해야 함:
// path("membership/<int:pk>/", UserMembershipMeDetailView.as_view())
export const deleteMembership = (id) => api.delete(`membership/${id}/`);
